(function ()
{
  $(document).ready(function ()
  {

    $(document).on('swell:setup', function ()
    {
      Swell.Referral.initializeReferral(".swell-referral", SwellConfig.Referral.opts);
      removeLoader("refer");
      SwellConfig.Referral.populateRedemptionOffers();
      removeLoader("refer");
      Swell.Campaign.initializeCampaigns(".swell-campaign-list", SwellConfig.Campaign.opts);
      SwellConfig.Campaign.AddExtraList();
      removeLoader("campaign");
      $(".swell-post-checkout").css("display", "flex");
      $("body").on("click", ".checkout-heading .swell-referral-back-link", function ()
      {
        $(".swell-post-checkout").css("display", "none");
      });
    });

    $("body").on("click", ".swell-share-referral-copy", function ()
    {
      setTimeout(function ()
      {
        $(".swell-referral-copy-link").html($(".swell-referral-copy-link").html().replace("http://", ""));
        $(".swell-referral-copy-link").html($(".swell-referral-copy-link").html().replace("https://", ""));
      }, 20);
    });

    $(document).on("swell:referral:success", function ()
    {
      swellAPI.refreshCustomerDetails(function ()
      {
        $(".table-data").html("");
        SwellConfig.Referral.populateRedemptionOffers();
      });
    });

    $(document).on("swell:referral:error", function (jqXHR, textStatus, errorThrown)
    {
      if (textStatus && textStatus === "EMAILS_ALREADY_PURCHASED")
      {
        $(".refer-customer-error").remove();
        $(".swell-referral-form-list").before('<p class="refer-customer-error">Sorry! Looks like this person has already made a purchase. Try referring another friend.</p>');
      }
      if (textStatus && textStatus === "Please enter a valid email address")
      {
        $(".refer-customer-error").remove();
        $(".swell-referral-form-list").before('<p class="refer-customer-error">Please enter valid email addresses separated with commas</p>');
      }
    });
  });
}).call(this);

(function ()
{
  window.SwellConfig = window.SwellConfig ||
  {};
  SwellConfig.Campaign = {
    opts:
    {
      templates:
      {
        campaign: '<li class="swell-campaign"> <div class="swell-campaign-link swell-campaign-content" data-display-mode="modal" data-campaign-id="<%= campaign.id %>"> <div class="swell-campaign-content-holder"> <div class="swell-campaign-icon-holder"> <div class="swell-campaign-icon"> <span class="swell-campaign-icon-content"><span class="<%= campaign.icon %>"></span></span></div> </div> <div class="swell-campaign-detail-holder"> <div class="swell-campaign-value"> <span class="swell-campaign-value-content"><%= campaign.reward_text %></span> </div> <div class="swell-campaign-type"> <span class="swell-campaign-type-content"><%= campaign.title %></span> </div> </div> </div> </div> </li>'
      }
    },

    AddExtraList: function ()
    {
      $(".swell-campaign-list .swell-campaign .swell-campaign-content[data-campaign-id = '503711']").parent().remove();
    }
  };
}).call(this);

(function ()
{
  window.SwellConfig = window.SwellConfig ||
  {};
  SwellConfig.Referral = {
    opts:
    {
      localization:
      {
        referralSidebarDetailsAction: "Refer a Friend",
        referralSidebarDetailsReward: "<%= referralCampaign.reward_text %>",

        referralRegisterHeading: "Give $20, Get $20",
        referralRegisterFormDetails: "Enter your email below to get started",
        referralRegisterFormEmail: "ENTER EMAIL",
        referralRegisterFormSubmit: "NEXT",
        referralRegisterDetails: "Give your friends $20 off on their first order of $100+ and get $20 in points for each successful referral.",

        referralReferHeading: "Give $20, Get $20",
        referralReferFormEmails: "Your Friends' Emails (separated by commas)",
        referralReferFormSubmit: "SEND",
        referralReferFormDetails: "Now, Enter your friends' emails.",
        referralReferFormEmailsDetails: "",
        referralReferDetails: "Give your friends $20 off on their first order of $100+ and get $20 in points for each successful referral.",
        referralReferMediaDetails: "You can also share your link with the buttons below.",

        referralShareFacebook: "Share",
        referralShareTwitter: "Tweet",
        referralShareCopy: "Copy Link",
        referralShareMessenger: "Message",
        referralShareSMS: "SMS",

        referralReferMediaIcon: "swell-referral-media-icon swell-icon-facebook-share-mob",
        referralTwitterIcon: "swell-referral-media-icon swell-icon-tweet-mob",
        referralLinkIcon: "swell-referral-media-icon swell-icon-copy-link-mob",
        referralMessengerIcon: "swell-referral-media-icon swell-icon-fb-message-mob",
        referralSMSIcon: "swell-referral-media-icon swell-icon-sms-mob",

        referralThanksHeading: "Thanks for Referring!",
        referralThanksDetails: "Remind your friends to check their emails.",

        referralCopyHeading: "",
        referralCopyButton: "Copy Link",
        referralCopyDetails: "Copy link and share with your friends."
      },
      templates:
      {
        referralRegister: '<div class="swell-referral-register"> <h2 class="swell-referral-heading"><span class="refer-friend-heading"><%= localization.referralSidebarDetailsAction %></span><%= localization.referralRegisterHeading %></h2> <p class="swell-referral-details"><%= localization.referralRegisterDetails%></p> <div class="swell-border"></div> <div class="swell-referral-form-wrapper"> <form class="swell-referral-form" name="swell-referral-register-form" id="swell-referral-register-form" method="POST" action="."> <div class="swell-referral-form-header"> <p class="swell-referral-form-header-details"><%= localization.referralRegisterFormDetails%></p> </div> <div class="swell-referral-form-body"> <ul class="swell-referral-form-list"> <li class="swell-referral-form-list-field"> <input class="swell-referral-form-list-field-input" type="email" name="swell-referral-register-email" id="swell-referral-register-email" required="required" placeholder="<%= localization.referralRegisterFormEmail %>"> </li> <li class="swell-referral-form-list-field"> <button class="swell-referral-form-list-submit" name="swell-referral-register-submit" id="swell-referral-register-submit"><%= localization.referralRegisterFormSubmit %></button> </li> </ul> </div> </form> </div> </div>',
        referralRefer: '<div class="swell-referral-refer"> <h2 class="swell-referral-heading"><span class="refer-friend-heading"><%= localization.referralSidebarDetailsAction %></span><%= localization.referralReferHeading %></h2> <p class="swell-referral-details"><%= localization.referralReferDetails%></p> <div class="swell-border"></div> <div class="swell-referral-form-wrapper"> <form class="swell-referral-form" name="swell-referral-refer-form" id="swell-referral-refer-form" method="POST" action="."> <div class="swell-referral-form-header"> <p class="swell-referral-form-header-details"><%= localization.referralReferFormDetails%></p> </div> <div class="swell-referral-form-body"> <ul class="swell-referral-form-list"> <li class="swell-referral-form-list-field"> <input class="swell-referral-form-list-field-input" type="email" name="swell-referral-refer-emails" id="swell-referral-refer-emails" required="required" placeholder="<%= localization.referralReferFormEmails %>"> </li> <li class="swell-referral-form-list-field"> <button class="swell-referral-form-list-submit" name="swell-referral-refer-submit" id="swell-referral-refer-submit"><%= localization.referralReferFormSubmit %></button> </li> </ul> </div> </form> </div> <div class="swell-referral-media-wrapper"> <p class="swell-referral-media-details"><%= localization.referralReferMediaDetails %></p> <ul class="swell-referral-media-list"> <li class="swell-referral-medium swell-share-referral-facebook"> <div class="swell-referral-medium-content"> <i class="<%= localization.referralReferMediaIcon %>" aria-hidden="true"></i><%= localization.referralShareFacebook %> </div> </li> <li class="swell-referral-medium swell-share-referral-twitter"> <div class="swell-referral-medium-content"> <i class="<%= localization.referralTwitterIcon %>" aria-hidden="true"></i><%= localization.referralShareTwitter %> </div> </li> <li class="swell-referral-medium swell-share-referral-sms"> <div class="swell-referral-medium-content"> <i class="<%= localization.referralSMSIcon %>" aria-hidden="true"></i><%= localization.referralShareSMS %> </div> </li> <li class="swell-referral-medium swell-share-referral-messenger"> <div class="swell-referral-medium-content"> <i class="<%= localization.referralMessengerIcon %>" aria-hidden="true"></i><%= localization.referralShareMessenger %> </div> </li> <li class="swell-referral-medium swell-share-referral-copy"> <div class="swell-referral-medium-content"> <i class="<%= localization.referralLinkIcon%>" aria-hidden="true"></i><%= localization.referralShareCopy %> </li> </ul> </div> </div>'
      }
    },

    populateRedemptionOffers: function ()
    {
      if (spapi.authenticated)
      {
        var receipts = spapi.customer.referral_receipts;
        var email;
        var completed_at;
        var status;
        var rewards_points;

        receipts.forEach(function (ref_receipts)
        {
          email = ref_receipts.email;
          completed_at = ref_receipts.completed_at;
          rewards_points = spapi.activeReferralCampaign.reward_text;

          if (completed_at)
          {
            status = "purchased(" + rewards_points + " earned)";
          }
          else
          {
            status = "invited";
          }
          $(".table-data").append("<tr> <td> " + email + "</td> <td>" + status + "</td></tr>");
        });
      }
    },
  };
}).call(this);

function removeLoader(section)
{
  $(".swell-loader-spinner." + section).remove();
}
